<template>
    <div id="app">
        <input class="initialData" v-model="text" placeholder="Введите текст" autofocus>
        <convertedData :text="translate" />
    </div>
</template>

<script>
import convertedData from '@/components/convertedData'

export default {
    data() {
        return {
            text: ''
        }
    },
    components: {
        convertedData
    },
    computed: {
        translate: function() {
            let text = this.text.toLowerCase().replace(/ +/g, ' ').trim()

            let chars = new Array(
                ['а', 'a'],
                ['б', 'b'],
                ['в', 'v'],
                ['г', 'g'],
                ['д', 'd'],
                ['е', 'e'],
                ['ё', 'yo'],
                ['ж', 'zh'],
                ['з', 'z'],
                ['и', 'i'],
                ['й', 'j'],
                ['к', 'k'],
                ['л', 'l'],
                ['м', 'm'],
                ['н', 'n'],
                ['о', 'o'],
                ['п', 'p'],
                ['р', 'r'],
                ['с', 's'],
                ['т', 't'],
                ['у', 'u'],
                ['ф', 'f'],
                ['х', 'h'],
                ['ц', 'ts'],
                ['ч', 'ch'],
                ['ш', 'sh'],
                ['щ', 'sch'],
                ['ъ', ''],
                ['ы', 'y'],
                ['ь', ''],
                ['э', 'e'],
                ['ю', 'yu'],
                ['я', 'ya'],
                ['a', 'a'],
                ['b', 'b'],
                ['c', 'c'],
                ['d', 'd'],
                ['e', 'e'],
                ['f', 'f'],
                ['g', 'g'],
                ['h', 'h'],
                ['i', 'i'],
                ['j', 'j'],
                ['k', 'k'],
                ['l', 'l'],
                ['m', 'm'],
                ['n', 'n'],
                ['o', 'o'],
                ['p', 'p'],
                ['q', 'q'],
                ['r', 'r'],
                ['s', 's'],
                ['t', 't'],
                ['u', 'u'],
                ['v', 'v'],
                ['w', 'w'],
                ['x', 'x'],
                ['y', 'y'],
                ['z', 'z'],
                [' ', '-'],
                ['.', '-'],
                ['0', '0'],
                ['1', '1'],
                ['2', '2'],
                ['3', '3'],
                ['4', '4'],
                ['5', '5'],
                ['6', '6'],
                ['7', '7'],
                ['8', '8'],
                ['9', '9'],
                ['-', '-'],
                ['_', '-']
            )

            let newStr = new String();

            for (let i = 0; i < text.length; i++) {
                let ch = text.charAt(i);
                let newCh = '';

                for (let j = 0; j < chars.length; j++) {
                    if (ch == chars[j][0]) {
                        newCh = chars[j][1];
                    }
                }
                newStr += newCh;
            }
                return newStr
            }
        }
    }
</script>

<style>
#app {
    display: flex;
    justify-content: space-between;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.initialData {
    width: 45vw;
    max-width: 45vw;
    padding: 20px;
}
</style>